var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer",attrs:{"id":"footer"}},[_vm._v(" © 2020 YouWish AS. All rights reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }